import { Navigate, useParams } from 'react-router';

const LegacyPathRedirect = () => {
  const { workspace, planId } = useParams();
  return <Navigate to={`/repo/${workspace}/home/apply-log/${planId}`} />;
};

export default LegacyPathRedirect;
